// @ts-nocheck


import React, { useEffect } from 'react'
import Slider from 'react-slick'
import Link from 'next/link'
import ClubSlider from 'src/components/StoreAndProductDetailModal/ClubModal/ClubSlider'
import { guestAccountDetailSlice } from 'src/store/slices/guestAccountDetailSlice'
import { useAppDispatch } from 'src/store/store'
import { useAuth } from 'src/utils/auth'
import AosAnimation from 'src/utils/AosAnimation'
import { fetchManageClubsData } from 'src/store/slices/fetchAllClubsSlice'
import { useSelector } from 'react-redux'

const SampleNextArrow = (props) => {
  const { onClick } = props
  return (
    <div className="slick-arrow slick-next" onClick={onClick}>
      <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 1L1 6L5 11" stroke="#1E2432" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </div>
  )
}

const SamplePrevArrow = (props) => {
  const { onClick } = props
  return (
    <div className={'slick-arrow slick-prev'} onClick={onClick}>
      <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 1L1 6L5 11" stroke="#1E2432" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </div>
  )
}

export default function WomenFashionGroup(props) {
  const { user }: any = useAuth()
  const dispatch = useAppDispatch()
  const allManageClub = useSelector((state: any) => state?.clubData?.manageClubs)

  const settings_Slider4 = {
    dots: false,
    infinite: false,
    speed: 1000,
    slidesToShow: 2.5,
    slidesToScroll: 3,
    autoplay: true,
    autoplaySpeed: 10000,
    pauseOnHover: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.03,
          slidesToScroll: 1,
          // initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.02,
          slidesToScroll: 1,
        },
      },
    ],
  }

  const leaveClubYouManageCall = (club) => {
    if (user) {
    } else {
      handleRedirect()
    }
  }

  const joingroupCall = (club) => {
    if (user) {
    } else {
      handleRedirect()
    }
  }

  const handleRedirect = () => {
    dispatch(
      guestAccountDetailSlice({
        modal: 'authModal',
        isOpen: true,
        id: {
          media: 'https://storage.googleapis.com/bluejestic-media/bluejestic-stage/loginmedia/Live-Shopping-Short.mp4',
          modalFor: 'login',
          startWith: 'loginModal',
        },
      }),
    )
  }

  useEffect(() => {
    dispatch(fetchManageClubsData({ page: 1, limit: 100, type: 'SUGGESTED_CLUBS' }))
  }, [])

  return (
    <div>
      {allManageClub?.length ? (
        <AosAnimation animationType="fade-up" duration={900}>
          <div className="section_7_heading">
            <h4>Fashion Club</h4>
            <Link
              href={{
                pathname: `/fashion/women`,
                query: { type: 'club' },
              }}
              scroll={false}
            >
              <div className="mobile_view_seeMore">
                <a>See More</a>
              </div>
            </Link>
          </div>
          <section className="section_7">
            <div className="container">
              <div className="row section_3_row">
                <div className="left_block">
                  <div className="left_cover">
                    <h3>
                      Fashion <br /> Club
                    </h3>
                    <Link
                      href={{
                        pathname: `/fashion/women`,
                        query: { type: 'club' },
                      }}
                      scroll={false}
                    >
                      <a>
                        Explore More
                        {/* <RightOutlined /> */}
                      </a>
                    </Link>
                  </div>
                </div>
                <div className="right_block">
                  <div className="right_block_cover">
                    {allManageClub?.length > 2 ? (
                      <div className="Fashion_Group_slider">
                        <Slider {...settings_Slider4}>
                          {allManageClub?.map((club, index) => {
                            return (
                              <React.Fragment key={index}>
                                <ClubSlider
                                  club={club}
                                  leaveGroupCall={leaveClubYouManageCall}
                                  joingroupCall={joingroupCall}
                                  isOpen={true}
                                />
                              </React.Fragment>
                            )
                          })}
                        </Slider>
                      </div>
                    ) : (
                      <>
                        <div className="Fashion_Group_slider">
                          <div className="fashion-group-slider-grid">
                            {allManageClub?.map((club, index) => {
                              return (
                                <React.Fragment key={index}>
                                  <ClubSlider
                                    club={club}
                                    leaveGroupCall={leaveClubYouManageCall}
                                    joingroupCall={joingroupCall}
                                    isOpen={true}
                                  />
                                </React.Fragment>
                              )
                            })}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </AosAnimation>
      ) : (
        ''
      )}
    </div>
  )
}
